// removed by extract-text-webpack-plugin
module.exports = {"TextInput":"TextInput__3NK1b","Label":"Label__HJ7EG"};